import { OptionModel } from "@generation/schema-core/src/client/model/options/optionModel";
import { translate } from "@opencak-klantondersteuning/shared";

export const voorMezelfIkBenKlantOptie: string = "voorMezelfIkBenKlant";

export const voorIemandAndersDieKlantIsOptie: string = "voorIemandAndersDieKlantIs";

export const voorMezelfIkBenGeenKlantOptie: string = "voorMezelfIkBenGeenKlant";

export const voorWieSteltUDeVraagOptions = (): OptionModel[] => [
  {
    value: voorMezelfIkBenKlantOptie,
    label: translate("ContactFormulier.VoorMijzelfIkBenKlant")
  },
  {
    value: voorIemandAndersDieKlantIsOptie,
    label: translate("ContactFormulier.VoorIemandAndersDieKlantIs")
  },
  {
    value: voorMezelfIkBenGeenKlantOptie,
    label: translate("ContactFormulier.VoorMijzelfIkBenGeenKlant")
  }
];
